import React, { useState } from 'react';
import { usePWAInstall } from '../../hooks/usePWAInstall';
import { useDataAuth } from '../../hooks/useDataAuth';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import MenuItem from '@mui/material/MenuItem';
import Toolbar from '@mui/material/Toolbar';
import Divider from '@mui/material/Divider';
import AppBar from '@mui/material/AppBar';
import Menu from '@mui/material/Menu';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { AccountCircleOutlined, AccountCircleRounded, HelpRounded, Menu as MenuIcon, SupportAgentRounded } from '@mui/icons-material';
import styled from '@emotion/styled';
import LoadingOverlay from '../../components/others/LoadingOverlay';
import LanguageSwitcher from '../others/LanguageSwitcher';
import CompanySelector from '../others/CompanySelector';
import { UpdatePassword } from '../users/UpdatePassword';
import { logout } from '../../redux/actions/auth';
import { NavbarNavigationResolver } from '../others/NavbarNavigationResolver';

const drawerWidth = 260;
const drawerWidthClose = 80;
const StyledAppBar = styled(AppBar, {
    shouldForwardProp: (prop) => prop !== 'open' && prop !== 'isMobile',
})(({ theme, open, isMobile }) => ({
    transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    background: !isMobile ? theme.navbar.main : theme.navbar.secondary,
    ...(!isMobile && {
        marginLeft: open ? drawerWidth : drawerWidthClose,
        width: open ? `calc(100% - ${drawerWidth}px)` : `calc(100% - ${drawerWidthClose}px)`,
    }),
}));

export const Navbar = ({ openDrawer, handleDrawerOpen, onChatToggle }) => {
    const [{ handleLogout, userSession }] = useDataAuth();
    const { isMobileScreen } = usePWAInstall();
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [anchorElMenuUser, setAnchorElMenuUser] = useState(null);
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const openMenuUser = Boolean(anchorElMenuUser);

    const handleClickMenuUser = (event) => setAnchorElMenuUser(event.currentTarget);
    const handleCloseMenuUser = () => setAnchorElMenuUser(null);
    const handleClickLogout = () => {
        setAnchorElMenuUser(null);
        handleLogout();
        dispatch(logout());
    };

    const handleCancel = () => {
        setOpen(false);
        setLoading(false);
    }

    return (
        <>
            <StyledAppBar
                position="fixed"
                elevation={0}
                open={openDrawer}
                isMobile={isMobileScreen}
            >
                <Toolbar variant="dense" sx={{ justifyContent: "space-between", px: 2 }}>
                    {isMobileScreen && (
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                            <IconButton color="inherit" aria-label="open drawer" edge="start" sx={{ marginRight: 2 }}
                                onClick={handleDrawerOpen}
                            >
                                <MenuIcon color="primary" />
                            </IconButton>
                        </Box>
                    )}

                    <Grid
                        container
                        alignItems="center"
                        justifyContent="flex-start"
                        sx={{ width: "auto", flexGrow: 1 }}
                    >
                        <CompanySelector isMobileScreen={isMobileScreen} />
                    </Grid>

                    <Grid
                        container
                        alignItems="center"
                        justifyContent="flex-end"
                        sx={{ width: "auto", flexGrow: 1 }}
                    >
                        <NavbarNavigationResolver />

                        <Divider
                            orientation="vertical"
                            sx={{
                                borderColor: '#6728AF',
                                height: '24px',
                                alignSelf: 'center',
                                mx: 2,
                            }}
                        />

                        {/*<Typography>
                            Ayuda
                        </Typography>
                        <IconButton
                            color="inherit"
                            aria-label="IA-Asistente"
                            // onClick={onChatToggle}
                            edge="center"
                        >
                            <HelpRounded color="primary" />
                        </IconButton>

                        <Divider
                            orientation="vertical"
                            sx={{
                                borderColor: '#ffffff',
                                height: '24px',
                                alignSelf: 'center',
                                mx: 2,
                            }}
                        />

                        <LanguageSwitcher />

                        <Divider
                            orientation="vertical"
                            sx={{
                                borderColor: '#ffffff',
                                height: '24px',
                                alignSelf: 'center',
                                mx: 2,
                            }}
                        />

                        <Typography>
                            Asistente AI
                        </Typography>
                        <IconButton
                            color="inherit"
                            aria-label="IA-Asistente"
                            onClick={onChatToggle}
                            edge="center"
                        >
                            <SupportAgentRounded color="primary" />
                        </IconButton>

                        <Divider
                            orientation="vertical"
                            sx={{
                                borderColor: '#ffffff',
                                height: '24px',
                                alignSelf: 'center',
                                mx: 2,
                            }}
                        /> */}

                        {/* {!isMobileScreen && ( */}
                        <Typography
                            sx={{
                                color: isMobileScreen ? '#ffffff' : (theme) => theme.navbar.text
                            }}
                        >
                            {`${userSession.name} ${userSession.last_name}`}
                        </Typography>
                        {/* )} */}

                        <IconButton
                            size="large"
                            color="inherit"
                            aria-haspopup="true"
                            aria-controls={openMenuUser ? "user-menu" : undefined}
                            onClick={handleClickMenuUser}
                            className={openMenuUser ? "btnIcon active" : "btnIcon"}
                        >
                            <AccountCircleOutlined color="primary" className="icon-default" />
                            <AccountCircleRounded color="primary" className="icon-hover" />
                        </IconButton>

                        <Menu
                            keepMounted
                            id="user-menu"
                            anchorEl={anchorElMenuUser}
                            open={openMenuUser}
                            onClose={handleCloseMenuUser}
                        >
                            <MenuItem onClick={() => setOpen(true)}>
                                {t("newPassword.changePassword")}
                            </MenuItem>
                            <MenuItem onClick={handleClickLogout}>
                                {t("login.logout")}
                            </MenuItem>
                        </Menu>
                    </Grid>
                </Toolbar>
            </StyledAppBar>
            {open && <UpdatePassword open={open} cancel={handleCancel} setLoading={setLoading} />}
            {open && <LoadingOverlay isOpen={loading} />}
            {/* {open && <UpdatePassword open={open} setLoading={setLoading} Cancel={() => (setOpen(false), setLoading(false))} />}
            {open && <LoadingOverlay isOpen={loading} />} */}
        </>
    );
};
